import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Badge,
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap'

const SWAP_REASON_OPTIONS = [
  'Direct Sell',
  'Trade',
  'Buy Stock From Seller'
]

const DEFAULT_SWAP_REASON = 'Buy Stock From Seller'

const propTypes = {
  isOpen             : PropTypes.bool.isRequired,
  toggle             : PropTypes.func.isRequired,
  sku                : PropTypes.string,
  handleConfirmation : PropTypes.func.isRequired
}

const defaultProps = {
  sku: 'This product'
}

const SwapBkrToBkaConfirmationModal = ({
  isOpen,
  toggle,
  sku,
  handleConfirmation
}) => {
  const [ isSubmitting, setIsSubmitting ] = useState(false)
  const [ swapReason, setSwapReason ] = useState(DEFAULT_SWAP_REASON)

  const handleConfirm = async () => {
    if (!swapReason || isSubmitting) return

    setIsSubmitting(true)

    try {
      await handleConfirmation(swapReason)
    } catch (error) {
      setIsSubmitting(false)
      return error
    }
  }

  return (
    <Modal isOpen={ isOpen } toggle={ isSubmitting ? undefined : toggle } centered size="lg">
      <ModalHeader toggle={ isSubmitting ? undefined : toggle }>
        Confirm Swap BKR to BKA
      </ModalHeader>

      <ModalBody>
        <div className="mb-4">
          <div className="d-flex align-items-center mb-3">
            <Badge color="warning" pill className="px-3 py-2 mr-2">BKR</Badge>
            <i className="fas fa-arrow-right text-muted mr-2" />
            <Badge color="success" pill className="px-3 py-2 mr-3">BKA</Badge>
            <span className="font-weight-bold text-dark">{ sku || 'This product' }</span>
          </div>

          <p className="mb-0 text-muted">
            Sistem akan membuat SKU BKA baru dari product BKR ini.
            BKA baru akan masuk appraisal / pricing flow ulang sebelum available di customer web.
          </p>
        </div>

        <FormGroup>
          <Label className="font-weight-bold">{ 'Swap Reason' }</Label>
          <Input
            type="select"
            value={ swapReason }
            disabled={ isSubmitting }
            onChange={ (event) => setSwapReason(event.target.value) }
          >
            {
              SWAP_REASON_OPTIONS.map((reason) => (
                <option key={ reason } value={ reason }>
                  { reason }
                </option>
              ))
            }
          </Input>
          <small className="form-text text-muted">
            { 'Reason ini akan disimpan sebagai note old BKR dan menentukan inventory type BKA baru.' }
          </small>
        </FormGroup>

        <div className="border rounded p-3 mb-3 bg-light">
          <div className="font-weight-bold mb-2">Yang akan dilakukan sistem</div>
          <ul className="mb-0 pl-3 text-muted">
            <li>
              Membuat product BKA baru dengan IQ mengikuti physical stock BKR lama,
              tetapi SQ di-reset menjadi 0.
            </li>
            <li>
              Copy atribut BKR ke BKA, termasuk specs, kelengkapan,
              product size, relasi, dan foto. Buying Price/HM, Default Price, dan
              Selling Price/HJ dikosongkan; appraisal status dan price tag di-reset.
            </li>
            <li>
              Inventory type BKA baru akan mengikuti swap reason yang dipilih:
              Direct Sell, Trade, atau Buy Stock From Seller.
            </li>
            <li>
              Old BKR tetap <strong>Not Available</strong>, lalu set IQ 0 / SQ 0.
            </li>
            <li>
              Old BKR tetap tersimpan di database untuk audit/history,
              tapi di-hide dari inventory list operasional.
            </li>
          </ul>
        </div>

        <div className="alert alert-warning mb-0">
          Setelah confirm, proses ini tidak sekadar update tampilan.
          Sistem akan membuat SKU BKA baru dan menonaktifkan SKU BKR lama.
        </div>
      </ModalBody>

      <ModalFooter>
        <Button
          color="secondary"
          disabled={ isSubmitting }
          onClick={ toggle }
        >
          Cancel
        </Button>
        <Button
          color="primary"
          disabled={ isSubmitting || !swapReason }
          onClick={ handleConfirm }
        >
          { isSubmitting ? 'Processing...' : 'Confirm Swap' }
        </Button>
      </ModalFooter>
    </Modal>
  )
}

SwapBkrToBkaConfirmationModal.propTypes = propTypes
SwapBkrToBkaConfirmationModal.defaultProps = defaultProps

export default SwapBkrToBkaConfirmationModal
